<template>
    <a href="https://eda.yandex.ru/kazan/r/tyubetej" class="btnYandexFood"><span>Заказать в Яндекс Еде</span> <img src="@/assets/img/yandex-food/icon.png" alt="иконка" /></a>
</template>

<style lang="scss" scoped>
.btnYandexFood {
    width: 100%;
    max-width: 232px;
    min-height: 48px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fee233;
    font-family: "Nunito Sans Bold";
    font-size: 14px;
    line-height: 24px;
    color: #1f2120;
    margin: 0 auto;
    img {
        width: 24px;
        height: 24px;
        margin-left: 5px;
    }
}
</style>
